import { Controller } from "@hotwired/stimulus"

// Highlights the nav link whose section currently crosses the reading band
// (the upper third of the viewport). Links reference sections by their hash.
export default class extends Controller<HTMLElement> {
  static targets = ["link"]
  static classes = ["active"]

  declare readonly linkTargets: HTMLAnchorElement[]
  declare readonly activeClasses: string[]

  observer?: IntersectionObserver

  connect() {
    this.observer = new IntersectionObserver((entries) => this.highlight(entries), {
      rootMargin: "-120px 0px -65% 0px",
    })

    for (const link of this.linkTargets) {
      const section = document.getElementById(link.hash.slice(1))
      if (section) this.observer.observe(section)
    }
  }

  disconnect() {
    this.observer?.disconnect()
  }

  highlight(entries: IntersectionObserverEntry[]) {
    const topmost = entries
      .filter((entry) => entry.isIntersecting)
      .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top)[0]
    if (!topmost) return

    for (const link of this.linkTargets) {
      const active = link.hash === `#${topmost.target.id}`
      this.activeClasses.forEach((name) => link.classList.toggle(name, active))
    }
  }
}
